module.exports = __webpack_public_path__ + "img/safe-1.9f6b394f.png";